<div #dummyRef></div>

<div class="account-header-container">
  <div class="placeholder-el"></div>
  <div class="account-header" [class.sticky]="sticky">
    <div
      class="d-flex justify-content-end container px-8 px-xl-15 h-100 gap-6 gap-xl-9"
    >
      <ng-container *ngFor="let item of items">
        <digital-platform-account-header-item
          [item]="item"
          (itemClicked)="onItemClicked(item)"
        ></digital-platform-account-header-item>
      </ng-container>
    </div>
  </div>
</div>
